@import 'styles/variables';

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--dark-2);
  border-radius: 10px;
  min-height: 181px;
  padding: 24px;
  width: 100%;
}

.copy {
  max-width: 340px;
  text-align: center;
}
